<script setup lang="ts">
interface Props {
  position: { x: number; y: number };
}

defineProps<Props>();
</script>

<template>
  <div
    class="pointer-events-none fixed z-40 -translate-x-1/2 -translate-y-1/2"
    :style="{ left: `${position.x}px`, top: `${position.y}px` }"
  >
    <svg
      aria-hidden="true"
      fill="none"
      height="28"
      viewBox="0 0 28 28"
      width="28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 0.5H26C26.8284 0.5 27.5 1.17157 27.5 2V26C27.5 26.8284 26.8284 27.5 26 27.5H2C1.17157 27.5 0.5 26.8284 0.5 26V2L0.507812 1.84668C0.58461 1.09028 1.22334 0.5 2 0.5Z"
        fill="#55CECE"
        fill-opacity="0.3"
      />
      <path
        d="M2 0.5H26C26.8284 0.5 27.5 1.17157 27.5 2V26C27.5 26.8284 26.8284 27.5 26 27.5H2C1.17157 27.5 0.5 26.8284 0.5 26V2L0.507812 1.84668C0.58461 1.09028 1.22334 0.5 2 0.5Z"
        stroke="#36B8B8"
      />
      <path
        clip-rule="evenodd"
        d="M14 24C14 24 22 18 22 12C22 7.58154 18.4182 4 14 4C9.58179 4 6 7.58154 6 12C6 18 14 24 14 24ZM14 15C15.6567 15 17 13.6567 17 12C17 10.3433 15.6567 9 14 9C12.3433 9 11 10.3433 11 12C11 13.6567 12.3433 15 14 15Z"
        fill="#E8F0F3"
        fill-rule="evenodd"
      />
    </svg>
  </div>
</template>
